import { createFileRoute, redirect } from '@tanstack/react-router';

/** Les réglages s'ouvrent sur le compte. */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/account', replace: true });
  },
});
